export default "__VITE_ASSET__B5SpD0DH__"